<label for="{{id}}">{{t label}}</label>

<div class="slider-container">
  <div class="slider-wrapper">

    {{#if slider.enable_step_buttons}}
    <button type="button"
            class="slider-step minus"
            data-subject="{{ slider.subject }}"
            data-change="decrement"
            aria-label="{{ t 'slider.decrementBtn' }}">
    </button>
    {{/if}}

    {{#with labels}}
      {{#if slider.min}}
        {{> label description=slider.min}}
      {{else}}
        {{> label description=../min}}
      {{/if}}
    {{/with}}

    <div id="{{ id }}-{{ slider.subject }}"
        class="slider {{ slider.class }}"
        data-title="{{ t label }}"
        data-subject="{{ slider.subject }}">

      {{#each slider.points}}
        <div class="slider-index-{{ @index }} slider-position">
          <span class="icon"></span>
          {{#if slider.description}}<span class="text">{{ t slider.description }}</span>{{/if}}
        </div>
      {{/each}}

      <input type="range"
            id="{{ id }}"
            name="{{ slider.name }}"
            />
      <span class="slider-thumb-horizontal"></span>
    </div>

    {{#with labels}}
      {{#if slider.max}}
        {{> label description=slider.max}}
      {{else}}
        {{> label description=../max}}
      {{/if}}
    {{/with}}

    {{#if slider.enable_step_buttons}}
      <button type="button" class="slider-step plus" data-subject="{{ slider.subject }}" data-change="increment" aria-label="{{t 'slider.incrementBtn'}}"></button>
    {{/if}}
  </div>
</div>

{{#if slider.output_class}}
  <div class="{{ slider.output_class }}"></div>
{{/if}}
